import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import Time from "react-time-format";
import { Link } from "react-router-dom";
import { change_Lang } from "../../actions/Helper_action";
import Create_Admin from "./Create_Admin";
import { Get_List_Admin } from "../../actions/Admin_action";
import { Search } from "react-feather";
import { Input, Modal } from "antd";
const ListAdmin = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_List_Admin());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const [search, setsearch] = useState("");
  const [IsModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const get_admins_list = useSelector(
    (state) => state.AdminReducer.get_admins_list
  );
  const listAdmin_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };

  const datas = get_admins_list
    .filter((data) => {
      if (search !== "") {
        if (isNaN(search)) {
          return (
            data.fname &&
            data.fname.toLowerCase().startsWith(search.toLowerCase())
          );
        } else {
          return data.phone.toString().startsWith(search);
        }
      } else {
        return data;
      }
    })
    .map((el, i) => {
      return {
        bid: i + 1,
        phone: el.phone,
        fullname: (
          <span
            className={`${lang === "en" ? "" : "fk"}`}
          >{`${el.fname}  ${el.lname}`}</span>
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
          />
        ),
        status:
          el.status === "active" ? (
            <label style={{ color: "green" }}>{el.status}</label>
          ) : el.status === "suspend" ? (
            <label style={{ color: "#f0ad4e" }}>{el.status}</label>
          ) : el.status === "delete" ? (
            <label style={{ color: "red" }}>{el.status}</label>
          ) : (
            ""
          ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("id")),
      selector: "bid",
      sortable: true,
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Full Name")),
      selector: "fullname",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("profile_mob")),
      selector: "phone",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        background: "#e3e9f2",
      },
    },
  };

  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("List Admins"))}
          parent={dispatch(change_Lang("Admin"))}
        />
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk"
          }`}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-12 ">
              <div className="card" style={{ background: "" }}>
                <div className="row ">
                  <div className="col-md-3 mt-4 d-flex justify-content-start">
                    <Link onClick={showModal}>
                      <button className="btn  btn-sm px-4 py-2 exp_btn mr-3 mt-2">
                        {dispatch(change_Lang("Admin"))} &nbsp;
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </button>
                    </Link>
                    {/* &nbsp;
                    <Link to="/Print_list_admin" onClick={listAdmin_getPrint}>
                      <button className="btn  btn-sm px-4 py-2 exp_btn mt-2 mr-2">
                        {dispatch(change_Lang("Print"))}
                      </button>
                    </Link> */}
                  </div>
                  <div className="col-md-6 card-header">
                    <div
                      className=" text-center mt-2"
                      style={{ background: "" }}
                    >
                      <h3 style={{ fontWeight: "bold", color: "#4064d7" }}>
                        {dispatch(change_Lang("List Admins"))}
                      </h3>
                    </div>
                  </div>
                  <div className="col-md-3 m-auto" style={{ background: "" }}>
                    <div className="form-group form-inline d-flex justify-content-center mt-2">
                      <Input
                        type="text"
                        name="search"
                        value={search}
                        onChange={(e) => setsearch(e.target.value)}
                        size="middle"
                        placeholder={dispatch(change_Lang("Search"))}
                        autoComplete="off"
                        className="mt-2 ml-2"
                        style={{ width: "180px" }}
                        prefix={<Search color="lightgray" />}
                      />
                    </div>
                  </div>
                </div>
                <div className="user-status table-responsive latest-order-table">
                  <DataTable
                    columns={columns}
                    className={`${lang === "en" ? "" : "fk"}`}
                    customStyles={customStyles}
                    data={datas}
                    pagination
                    striped
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title={dispatch(change_Lang("Create Admin"))}
          className="fk"
          width={1200}
          open={IsModalVisible}
          onCancel={handleCancel}
          footer={false}
        >
          <div className="col-xl-12 py-3" style={{ background: "#f6f8fa" }}>
            <Create_Admin handleCancel={handleCancel} />
          </div>
        </Modal>
      </Fragment>
    </>
  );
};

export default ListAdmin;
